import { batch } from 'react-redux';

import { TContextDispatch } from '~/src/entities/speed-bonus/context';
import { setBusinessLogic } from '~/src/entities/speed-bonus/context/actions';
import { IBusinessLogic } from '~/src/entities/speed-bonus/context/actions/setBusinessLogic';
import { fetchRouters } from '~/src/entities/speed-bonus/context/actions/thunk/fetchRouters';

export const initialize = ({
    agreementId,
    ...initProps
}: Partial<IBusinessLogic>) => (dispatch: TContextDispatch) => {
    if (agreementId) {
        batch(() => {
            dispatch(setBusinessLogic({ agreementId, ...initProps }));
            dispatch(fetchRouters());
        });
    }
};
